import gql from "graphql-tag";

export const MY_HR_INACTIVATE_USERS = gql`
  mutation inactivateUsers(
    $inactivateDate: Date
    $roleFilters: RoleFilterInput
  ) {
    inactivateUsers(inactivateDate: $inactivateDate, roleFilters: $roleFilters)
  }
`;
